import type { APIService } from '../interfaces/services';
import type { AttachmentMeta } from '../types';

type CreateAttachmentResponse = {
  upload_uuid: string;
  presigned_post: {
    url: string;
    fields: Record<string, string>;
  };
};

export async function uploadAttachment(file: File, apiService: APIService): Promise<AttachmentMeta> {
  const extension = file.name.includes('.') ? file.name.split('.').pop()?.toLowerCase() ?? '' : '';

  const response = await apiService.post<CreateAttachmentResponse>('/api/v1/assistant/attachments/', {
    file_name: file.name,
    extension,
  });

  const { upload_uuid, presigned_post } = response;

  const formData = new FormData();
  Object.entries(presigned_post.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  const s3Response = await fetch(presigned_post.url, { method: 'POST', body: formData });
  if (!s3Response.ok) {
    throw new Error(`S3 upload failed: ${s3Response.status}`);
  }

  return { uuid: upload_uuid, fileName: file.name };
}
